import { api } from "@/APIRequests";
import type { UUID } from "@/core/types";

export type RemoveFromWaitListVariables = {
  patientId: UUID;
};

export async function removeFromWaitList({
  patientId,
}: RemoveFromWaitListVariables): Promise<void> {
  await api.patientTyped.remove_from_wait_list({
    params: { showLoader: false },
    patientId,
  });
}
